import { jsx as i } from "react/jsx-runtime";
import { ModalFooter as c } from "@chakra-ui/react";
import { useState as l, useEffect as f } from "react";
function w({ children: r, ...s }) {
  const [n, a] = l(!1), e = new ResizeObserver((o) => {
    const t = o[0].target, d = t.scrollHeight > t.clientHeight;
    a(d);
  });
  return f(() => {
    const o = document.querySelector("[id^='chakra-modal--body']");
    return o && e.observe(o), () => {
      o && e.unobserve(o);
    };
  }, []), /* @__PURE__ */ i(c, { boxShadow: n ? "0px 0px 16px rgba(0, 0, 0, 0.24)" : "none", ...s, children: r });
}
export {
  w as ModalFooter
};
